/**
 * The graph draws no account (Benoit, 2026-10-21: "do not show the user node"). An org with
 * networks of two owners drew two avatars, one of them huge.
 *
 * ⚠ The layout still needs one root: `layout.ts` gives each root a wedge of the circle, and
 * `force.ts` holds every ring around the first account. So every account becomes ONE root that
 * holds all the networks, and `core.ts` keeps it in the simulation but does not draw it, nor its
 * links. The map is not changed: it draws the viewer's account as the home icon.
 */
export const GRAPH_ROOT = 'graph-root'

/** The data with one root account, which owns every network that has an owner. */
export function oneRoot(data: MergedData): MergedData {
  if (!data.accounts.length && !data.networks.length) return data
  return {
    ...data,
    accounts: [{ id: GRAPH_ROOT, name: '', url: null }],
    networks: data.networks.map(network => (network.ownerId ? { ...network, ownerId: GRAPH_ROOT } : network)),
  }
}

/** True for a node the graph draws: every node but the root. */
export const drawnNode = (node: GraphNode) => node.type !== 'account'

/** True for a link the graph draws: every link but one from the root. */
export const drawnLink = (link: GraphLink) => link.sourceType !== 'account'
